import { Box, Link, Typography } from '@mui/material';
import { Trans } from '@lingui/macro';
import type { FC } from 'react';
import type { GateInMovement } from '../../slices/reducer';
import { BannerRow, type BannerRowPosition } from './BannerRow';
import { BorderLinearProgress } from './BorderLinearProgress';

/** Fila del sistema legacy (`gates_in_movement_store`), sin cambios de comportamiento. */
export const LegacyMovementRow: FC<BannerRowPosition & { gateInMovement: GateInMovement }> = ({
  gateInMovement,
  ...position
}) => {
  let message = <></>;
  const { gateId, gateName, startPosition, finishPosition } = gateInMovement;

  const roundedFinishPosition = Math.round(finishPosition * 100) / 100;
  const roundedStartPosition = Math.round(startPosition * 100) / 100;
  const error =
    gateInMovement.state === 'FINISHED_MOVING' &&
    Math.abs(finishPosition - gateInMovement.position) > 0.5;

  if (gateInMovement.state === 'STARTED_MOVING')
    message = (
      <Trans>
        !ATENCIÓN! La compuerta <b>{gateName}</b> ha comenzado a moverse
      </Trans>
    );
  if (gateInMovement.state === 'MOVING')
    message = (
      <Trans>
        La compuerta <b>{gateName}</b> se está moviendo
      </Trans>
    );
  if (gateInMovement.state === 'FINISHED_MOVING')
    message = (
      <>
        <Trans>La compuerta</Trans> <b>{gateName}</b>{' '}
        {error ? <Trans>ha sido detenida</Trans> : <Trans>ha terminado de moverse</Trans>}
      </>
    );

  const progressLabel = (
    <>
      <Trans>Posición inicial</Trans>: {roundedStartPosition} cm -{' '}
      <Trans>Posición objetivo</Trans>: {roundedFinishPosition} cm
    </>
  );
  const positionPercent =
    (Math.abs(gateInMovement.position - startPosition) / Math.abs(finishPosition - startPosition)) *
    100;

  return (
    <BannerRow {...position}>
      <Typography noWrap>{message} </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Box width={100}>
          <BorderLinearProgress
            variant={gateInMovement.state === 'STARTED_MOVING' ? 'indeterminate' : 'determinate'}
            value={positionPercent}
          />
        </Box>
        {gateInMovement.state !== 'STARTED_MOVING' && (
          <Typography variant="body2" color="#222" noWrap>
            {Math.round(positionPercent)}%
          </Typography>
        )}
      </Box>
      <Typography variant="body2" color="#222" noWrap>
        {progressLabel}
      </Typography>
      <Link
        href={`/gates/administration/${gateId}`}
        color="inherit"
        sx={{ fontWeight: 'bold' }}
        noWrap
      >
        <Trans>Ver más</Trans>
      </Link>
    </BannerRow>
  );
};
